import React from 'react';
import { Video, Phone, MessageSquare, Star, Calendar } from 'lucide-react';
export function LiveClasses() {
  const scrollToCalendar = () => {
    const calendarSection = document.getElementById('calendar-section');
    if (calendarSection) {
      calendarSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-910">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-911">
        {/* Page Header */}
        <div className="mb-12" data-id="element-912">
          <div className="flex items-center justify-center mb-6" data-id="element-913">
            <Video className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-914" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-915">
              In-Person and Zoom Classes
            </h1>
          </div>

          {/* View Calendar Button */}
          <div className="flex justify-center" data-id="element-916">
            <button onClick={scrollToCalendar} className="inline-flex items-center px-6 py-3 bg-brand-purple-600 text-white font-bold rounded-md hover:bg-brand-purple-700 transition-colors shadow-md hover:shadow-lg" data-id="element-917">
              <Calendar className="w-5 h-5 mr-2" data-id="element-918" />
              View Calendar
            </button>
          </div>
        </div>

        {/* Questions Section */}
        <div className="mb-12 bg-brand-purple-50 rounded-lg p-6 border-2 border-brand-purple-200 text-center" data-id="element-919">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-4" data-id="element-920">
            Questions?
          </h2>
          <div className="flex items-center justify-center text-lg" data-id="element-921">
            <Phone className="w-5 h-5 text-brand-purple-600 mr-2" data-id="element-922" />
            <span className="text-gray-700" data-id="element-923">Call or text to</span>
            <a href="tel:602-377-6207" className="ml-2 text-brand-purple-600 hover:text-brand-purple-700 font-bold" data-id="element-924">
              602-377-6207
            </a>
          </div>
        </div>

        {/* Testimonial */}
        <div className="mb-12 bg-white rounded-lg border-2 border-gray-200 p-8 shadow-sm" data-id="element-925">
          <div className="flex items-start mb-4" data-id="element-926">
            <MessageSquare className="w-8 h-8 text-brand-purple-600 mr-4 flex-shrink-0 mt-1" data-id="element-927" />
            <div data-id="element-928">
              <div className="flex items-center mb-3" data-id="element-929">
                <h3 className="text-lg font-bold text-gray-900 mr-2" data-id="element-930">
                  Testimonial from Kresta Davis, REALTOR®
                </h3>
                <div className="flex" data-id="element-931">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-932" />)}
                </div>
              </div>
              <p className="text-base text-gray-700 leading-relaxed italic" data-id="element-933">
                "Jon, once again, one of the BEST classes! I can tell you are
                spending time making Zoom work for you because it genuinely was
                one of the best zoom classes I have taken. Most are difficult to
                even stay awake, even with the polls! In person AND on Zoom,
                your classes are THE BEST!"
              </p>
            </div>
          </div>
        </div>

        {/* Free Classes Notice */}
        <div className="mb-12 bg-green-50 border-l-4 border-green-400 p-6 rounded-lg" data-id="element-934">
          <p className="text-xl font-bold text-gray-900 text-center" data-id="element-935">
            ****Classes are FREE unless indicated otherwise****
          </p>
        </div>

        {/* Salesperson Requirements */}
        <div className="mb-12 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-936">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-937">Salesperson</h2>
          <p className="text-base text-gray-900 mb-4" data-id="element-938">
            24 credit hours required every two years, with at least one class of
            each of the following credit type, plus 1 class for elective credit:
          </p>
          <ul className="space-y-2 mb-6" data-id="element-939">
            <li className="flex items-start" data-id="element-940">
              <span className="text-brand-purple-600 mr-2" data-id="element-941">*</span>
              <span className="text-base text-gray-900" data-id="element-942">Agency Law</span>
            </li>
            <li className="flex items-start" data-id="element-943">
              <span className="text-brand-purple-600 mr-2" data-id="element-944">*</span>
              <span className="text-base text-gray-900" data-id="element-945">Contract Law</span>
            </li>
            <li className="flex items-start" data-id="element-946">
              <span className="text-brand-purple-600 mr-2" data-id="element-947">*</span>
              <span className="text-base text-gray-900" data-id="element-948">Disclosure</span>
            </li>
            <li className="flex items-start" data-id="element-949">
              <span className="text-brand-purple-600 mr-2" data-id="element-950">*</span>
              <span className="text-base text-gray-900" data-id="element-951">Fair Housing</span>
            </li>
            <li className="flex items-start" data-id="element-952">
              <span className="text-brand-purple-600 mr-2" data-id="element-953">*</span>
              <span className="text-base text-gray-900" data-id="element-954">
                General - Deed Fraud, Firewise + AZ Water
              </span>
            </li>
            <li className="flex items-start" data-id="element-955">
              <span className="text-brand-purple-600 mr-2" data-id="element-956">*</span>
              <span className="text-base text-gray-900" data-id="element-957">Legal Issues</span>
            </li>
            <li className="flex items-start" data-id="element-958">
              <span className="text-brand-purple-600 mr-2" data-id="element-959">*</span>
              <span className="text-base text-gray-900" data-id="element-960">
                Requirements for Licensees (formerly Commissioner's Standards)
              </span>
            </li>
          </ul>
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded" data-id="element-961">
            <p className="text-base text-gray-900" data-id="element-962">
              <strong data-id="element-963">1 class (3 hours) for elective credit</strong> - You may
              choose any credit type, providing you do not duplicate any course
              title you have already taken within that renewal period.
            </p>
          </div>
        </div>

        {/* Calendar Embed Placeholder */}
        <div id="calendar-section" className="bg-white rounded-lg border-2 border-gray-200 p-8 scroll-mt-40" data-id="element-964">
          <div className="mb-6" data-id="element-965">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-966">
              Class Schedule
            </h2>
          </div>

          {/* Example Calendar Image from Screenshot */}
          <div data-id="element-967">
            <img src="https://cdn.magicpatterns.com/uploads/3ZKpyqBfkEKB12J1Xpf28Z/image.png" alt="Class Schedule Calendar Example" className="w-full rounded-lg border border-gray-200" data-id="element-968" />
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-12 grid md:grid-cols-2 gap-6" data-id="element-969">
          <div className="bg-brand-purple-50 rounded-lg p-6 border border-brand-purple-100" data-id="element-970">
            <h3 className="text-xl font-bold text-brand-purple-900 mb-3" data-id="element-971">
              In-Person Classes
            </h3>
            <p className="text-base text-gray-700" data-id="element-972">
              Join us in person for engaging, interactive continuing education
              classes. Network with fellow real estate professionals while
              earning your CE credits.
            </p>
          </div>
          <div className="bg-blue-50 rounded-lg p-6 border border-blue-100" data-id="element-973">
            <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-974">
              Zoom Classes
            </h3>
            <p className="text-base text-gray-700" data-id="element-975">
              Attend from anywhere with our interactive Zoom classes. Get the
              same quality instruction and engagement from the comfort of your
              home or office.
            </p>
          </div>
        </div>

        {/* Contact CTA */}
        <div className="mt-12 bg-brand-purple-50 rounded-lg p-8 text-center border border-brand-purple-100" data-id="element-976">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-4" data-id="element-977">
            Ready to Register?
          </h2>
          <p className="text-gray-700 mb-6" data-id="element-978">
            Have questions about upcoming classes or need help registering?
            We're here to help!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-979">
            <a href="tel:602-377-6207" className="inline-flex items-center justify-center px-8 py-3 bg-brand-purple-600 text-white font-bold rounded-md hover:bg-brand-purple-700 transition-colors" data-id="element-980">
              <Phone className="w-5 h-5 mr-2" data-id="element-981" />
              Call 602-377-6207
            </a>
            <a href="/Contact" className="inline-flex items-center justify-center px-8 py-3 bg-white text-brand-purple-600 font-bold rounded-md border-2 border-brand-purple-600 hover:bg-brand-purple-50 transition-colors" data-id="element-982">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>;
}